import { Link } from 'react-router-dom';

export function AuthLegalNotice() {
  return (
    <p className="text-xs text-gray-500 font-sans font-normal text-center">
      Ao continuar, você concorda com nossos
      <br />
      <Link
        to="/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-[#171717]"
      >
        Termos de Uso
      </Link>
      {' '}e{' '}
      <Link
        to="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-[#171717]"
      >
        Política de Privacidade
      </Link>
    </p>
  );
}
